<template lang="pug" src="./account-balance-histories.pug"> </template>
<style lang="scss" src="./account-balance-histories.scss" scoped> </style>

<script>
import { mapGetters, mapState } from 'vuex'
import copyToClipboard from '@/utils/copy'
import scroll from '@/utils/scroll'

export default {
    data: () => ({
        numberOfColumns: {
            admin: 9,
            leader: 5,
            business: 5
        },
        filters: {
            leader: null,
            business: null,
            fromDate: null,
            toDate: null,
            taxiOrderId: null,
            clientPhone: null,
            enrollmentType: null
        },
        sorting: {}
    }),
    computed: {
        ...mapGetters(['type', 'permissions']),
        ...mapState({
            accountBalanceHistories: (state) => state.accountBalanceHistory.accountBalanceHistories,
            leaders: state => state.data.leaders,
            businesses: state => state.data.businesses,
            appliedFilters: state => state.accountBalanceHistory.filters,
            pagination: state => state.accountBalanceHistory.pagination,
            isTableLoad: state => state.accountBalanceHistory.isLoaded,
            user: state => state.app.user
        }),
        enrollmentType: function() {
            return ['refill', 'trip', 'delivery'].map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.AccountBalanceHistory.table.statuses.${it}`),
                type: it
            }))
        },
        hidden: function() {
            return this.user && this.user.type != 'admin' && !this.user.includeInBetaTesting
        },
        headers: function() {
            return [
                { text: '№', sortable: false, show: ['leader', 'business'], number: true },
                { text: 'clientId', value: '"orderCommission"."userPhoneId"', show: ['admin'] },
                { text: 'phoneNumber', sortable: false, value: 'clientPhone', show: ['admin'] },
                { text: 'taxiOrderId', value: '"orderCommission"."taxiOrderId"', show: ['admin'] },
                { text: 'change', value: 'change' },
                { text: 'balance', value: 'balance' },
                { text: 'partner', value: '"account"."type"', show: ['admin'] },
                { text: 'type', value: 'type' },
                { text: 'email', value: '"account"."email"', show: ['admin'] },
                { text: 'createdAt', value: '"AccountBalanceHistory"."createdAt"' }
            ]
                .filter(it => it.show ? this.isShow(it.show) : true)
                .filter(it => typeof it.hidden == 'boolean' ? !it.hidden : true)
                .map(it => Object.assign(it, {
                    text: it.number ? it.text : this.$vuetify.lang.t(`$vuetify.pages.AccountBalanceHistory.table.${it.text}`)
                }))
        }
    },
    watch: {
        sorting: {
            handler() {
                this.getAccountBalanceHistoriesByPage()
            },
            deep: true
        }
    },
    created: function() {
        const assoc = {
            admin: 'getLeaders',
            leader: 'getBusinesses'
        }

        if (assoc[this.type]) {
            this.$store.dispatch(assoc[this.type])
        }

        if (this.permissions && this.permissions.includes('watch-business') && !this.permissions.includes('watch-leaders')) {
            this.$store.dispatch('getBusinesses')
        }

        this.filters = Object.assign({}, this.appliedFilters)
        this.getAccountBalanceHistoriesByPage(1)
    },
    beforeRouteLeave: function(to, from, next) {
        this.$store.commit('accountBalanceHistory/SET_PAGINATION', { page: 1, length: null })
        this.$store.commit('accountBalanceHistory/RESET_ACCOUNT_BALANCE_HISTORIES')
        next()
    },
    methods: {
        getAccountBalanceHistoriesByPage(page = 1, isScrollEnable = false, excel = false) {
            this.$store.dispatch('accountBalanceHistory/getAccountBalanceHistories', {
                excel,
                page,
                column: this.sorting.sortBy,
                direction: this.sorting.descending ? 'desc' : 'asc',
                ...this.appliedFilters
            }).then(_ => {
                if (isScrollEnable) {
                    scroll(this.$refs.table)
                }
            })
        },
        submit() {
            this.$store.commit('accountBalanceHistory/SET_FILTERS', Object.assign({}, this.filters))
            this.getAccountBalanceHistoriesByPage()
        },
        changeFromDate(date) {
            this.filters.fromDate = date
        },
        changeToDate(date) {
            this.filters.toDate = date
        },
        isShow(types) {
            return types.includes(this.type)
        },
        onLeaderSelect(leader) {
            if (leader) {
                this.$store.dispatch('getBusinesses', {
                    leaderId: leader.id
                })
            }
            this.disabledBusiness()
            this.filters.business = null
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.getAccountBalanceHistoriesByPage(page, true)
            }
        },
        resetSelectedValues() {
            this.filters = Object.assign({}, {
                leader: null,
                business: null,
                fromDate: null,
                toDate: null,
                taxiOrderId: null,
                clientPhone: null
            })
            this.$store.commit('accountBalanceHistory/RESET_ACCOUNT_BALANCE_HISTORIES')
            this.getAccountBalanceHistoriesByPage()
        },
        disabledBusiness() {
            return (this.type === 'admin') ? !this.filters.leader : false
        },
        copy(text) {
            if (text) {
                copyToClipboard(text)
            }
        },
        exportToExcel() {
            this.getAccountBalanceHistoriesByPage(1, false, true)
        },
        changeBalanceType() {
            this.$store.commit('accountBalanceHistory/SET_ACCOUNT_BALANCE_HISTORIES', [])
            this.getAccountBalanceHistoriesByPage(1)
        }
    }
}
</script>
